import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useForm, Controller, useWatch } from "react-hook-form";
// @material-ui/core components
import {
  Divider,
  Typography,
  TextField,
  FormControl,
  Select,
  useMediaQuery,
  MenuItem,
  Grid,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import Lock from "@material-ui/icons/Lock";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "../components/GridContainer.js";
import GridItem from "../components/GridItem.js";
import CustomInput from "../components/CustomInput.js";
import Button from "../components/Button2.js";
import Card from "../components/Card2.js";
import CardBody from "../components/CardBody.js";
import CardHeader from "../components/CardHeader.js";
import CardFooter from "../components/CardFooter.js";

import styles from "../components/loginPageStyle.js";
import { useAlert } from "../components/Alert";
import LoadingFloating from "../components/LoadingFloating";
import divisions from "../divisions.json";
import { DateInput } from "../components/Form";

const useStyles = makeStyles(styles);

const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      id
      admin
      fullName
      branch
      ipAddress
      mobile
      identity
      token
    }
  }
`;

const REGISTER = gql`
  mutation register($userInput: UserInput!, $console: Boolean) {
    register(userInput: $userInput, console: $console) {
      id
    }
  }
`;

export default function LoginPage() {
  const history = useHistory();
  const Alert = useAlert();
  const [cardAnimaton, setCardAnimation] = useState("cardHidden");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [selectRegister, setSelectRegister] = useState(false);
  let divisionMap = [];
  for (const key in divisions) {
    divisionMap.push({
      label: key,
      value: divisions[key].zhTW,
      subdistrict: divisions[key].subdivisions,
    });
  }
  const genderArray = [
    { label: "男", value: "MALE" },
    { label: "女", value: "FEMALE" },
  ];
  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues: {
      fullName: "",
      username: "",
      password: "",
      gender: "",
      branch: "",
      // department: "",
      // position: "",
      fax: "",
      mobile: "",
      phone: "",
      email: "",
      birthday: null,
      address: "",
      district: "",
      subdistrict: "",
    },
  });
  const district = useWatch({ name: "district", control });
  React.useEffect(() => {
    let id = setTimeout(function () {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const classes = useStyles();

  const [login, { loading }] = useMutation(LOGIN, {
    onCompleted({ login }) {
      if (login) {
        localStorage.setItem("@fullhouseToken", login.token);
        localStorage.setItem("@fullhouseUserId", login.id);
        localStorage.setItem("@fullhouseUserBranch", login.branch);
        localStorage.setItem("@fullhouseFirst", "Y");
        localStorage.setItem("@fullhouseUserFullName", login.fullName);
        localStorage.setItem("@fullhouseUserMobile", login.mobile);
        localStorage.setItem("@fullhouseIpAddress", login.ipAddress);
        localStorage.setItem("@fullhouseIdentity", login.identity);
        localStorage.setItem("@fullhouseAdmin", JSON.stringify(login.admin));
        history.replace("/console/sale-obj");
      } else {
        return Alert.notice("帳號密碼錯誤");
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  const [register, { loading: registerLoading }] = useMutation(REGISTER, {
    onCompleted({ register }) {
      if (register) {
        return Alert.notice("註冊成功！", () =>
          history.replace("console/login")
        );
      } else {
        return Alert.notice("註冊失敗，請重新嘗試！");
      }
    },
    onError(error) {
      return Alert.notice(error.message.replace("GraphQL error: ", ""));
    },
  });

  function _login() {
    login({ variables: { username, password } });
  }

  function _register(data) {
    const { district, subdistrict, address, ...inputData } = data;

    const userInput = {
      ...inputData,
      address: {
        division: district,
        subdivision: subdistrict,
        address,
      },
      department: "管理部",
      position: "店長",
      identity: "FRANCHISEE",
    };

    register({ variables: { userInput, console: true } });
  }
  return (
    <div className={classes.container}>
      <LoadingFloating loading={loading || registerLoading} />
      {selectRegister ? (
        <Card>
          <CardHeader
            className={`${classes.cardHeader} ${classes.textCenter}`}
            color="rose"
          >
            <h1 className={classes.cardTitle}>註冊</h1>
          </CardHeader>
          <CardBody>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">姓名</Typography>
                <Controller
                  name="fullName"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">性別</Typography>
                <Controller
                  name="gender"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <FormControl fullWidth className={classes.fieldBox}>
                        <Select
                          fullWidth
                          displayEmpty
                          variant="outlined"
                          style={{ height: "40px" }}
                          {...field}
                        >
                          {genderArray?.map((item) => {
                            return (
                              <MenuItem value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error && (
                          <Typography
                            color="error"
                            variant="caption"
                            className={classes.helperText}
                          >
                            請填寫欄位
                          </Typography>
                        )}
                      </FormControl>
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">帳號</Typography>
                <Controller
                  name="username"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">密碼</Typography>
                <Controller
                  name="password"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField
                        className={classes.input}
                        type={"password"}
                        {...field}
                        fullWidth
                      />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">分店店名</Typography>
                <Controller
                  name="branch"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">手機</Typography>
                <Controller
                  name="mobile"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">電話</Typography>
                <Controller
                  name="phone"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              {/* <Grid item xs={12} sm={2}>
                      <Typography color="primary">部門</Typography>
                      <Controller
                        name="department"
                        control={control}
                        render={({ field }) => (
                          <TextField {...field} fullWidth />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <Typography color="primary">職位</Typography>
                      <Controller
                        name="position"
                        control={control}
                        render={({ field }) => (
                          <TextField {...field} fullWidth />
                        )}
                      />
                    </Grid> */}
              <Grid item xs={12} sm={2}>
                <Typography color="primary">傳真</Typography>
                <Controller
                  name="fax"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography color="primary">信箱</Typography>
                <Controller
                  name="email"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">生日</Typography>
                <Controller
                  name="birthday"
                  rules={{ required: true }}
                  control={control}
                  render={({
                    field: { value, onChange },
                    fieldState: { error },
                  }) => (
                    <>
                      <DateInput
                        openTo="year"
                        value={value}
                        onChange={onChange}
                        format={"yyyy/MM/dd"}
                        fullWidth
                      />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">縣市</Typography>
                <Controller
                  name="district"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => {
                    return (
                      <FormControl fullWidth className={classes.fieldBox}>
                        <Select
                          fullWidth
                          displayEmpty
                          variant="outlined"
                          style={{ height: "40px" }}
                          {...field}
                        >
                          <MenuItem value="" disabled>
                            縣市
                          </MenuItem>
                          {divisionMap?.map((item) => {
                            return (
                              <MenuItem value={item.label}>
                                {item.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error && (
                          <Typography
                            color="error"
                            variant="caption"
                            className={classes.helperText}
                          >
                            請填寫欄位
                          </Typography>
                        )}
                      </FormControl>
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <Typography color="primary">區域</Typography>
                <Controller
                  name="subdistrict"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => {
                    const selectSubIndex = divisionMap.findIndex(
                      (element) => element.label === district
                    );
                    const subDivisions =
                      divisionMap[selectSubIndex]?.subdistrict;
                    // 非陣列 把她變成陣列
                    let subDivisionsMap = [];
                    for (const key in subDivisions) {
                      subDivisionsMap.push({
                        label: key,
                        value: subDivisions[key].zhTW,
                      });
                    }

                    return (
                      <FormControl fullWidth className={classes.fieldBox}>
                        <Select
                          fullWidth
                          variant="outlined"
                          displayEmpty
                          style={{ height: "40px" }}
                          {...field}
                          disabled={!subDivisionsMap.length > 0 && true}
                        >
                          <MenuItem value="" disabled>
                            區域
                          </MenuItem>
                          {subDivisionsMap?.map((item) => {
                            return (
                              <MenuItem value={item.label}>
                                {item.value}
                              </MenuItem>
                            );
                          })}
                        </Select>
                        {error && (
                          <Typography
                            color="error"
                            variant="caption"
                            className={classes.helperText}
                          >
                            請填寫欄位
                          </Typography>
                        )}
                      </FormControl>
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography color="primary">地址</Typography>
                <Controller
                  name="address"
                  rules={{ required: true }}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextField {...field} fullWidth />
                      {error && (
                        <Typography
                          color="error"
                          variant="caption"
                          className={classes.helperText}
                        >
                          請填寫欄位
                        </Typography>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            <Button
              color="rose"
              simple
              size="lg"
              block
              onClick={handleSubmit(_register)}
            >
              送出
            </Button>
            <Button
              color="rose"
              simple
              size="lg"
              block
              onClick={() => {
                setSelectRegister(false);
              }}
            >
              返回
            </Button>
          </CardFooter>
        </Card>
      ) : (
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="rose"
                >
                  <h2 className={classes.cardTitle}>富屋法拍屋</h2>
                  <h1 className={classes.cardTitle}>管理後台</h1>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="帳號"
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                    }}
                    value={username}
                    onChange={setUsername}
                  />
                  <CustomInput
                    labelText="密碼"
                    id="password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Lock className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      type: "password",
                      autoComplete: "off",
                    }}
                    value={password}
                    onChange={setPassword}
                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  <Button
                    color="rose"
                    simple
                    size="lg"
                    block
                    onClick={() => {
                      setSelectRegister(true);
                    }}
                  >
                    註冊
                  </Button>
                  <Button color="rose" simple size="lg" block onClick={_login}>
                    登入
                  </Button>
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      )}
    </div>
  );
}

function Register(open, onClose = () => {}) {}
